import { Link } from "react-router-dom";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#0F172A] py-12 px-6 md:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="font-serif text-xl font-bold text-white">
              Next Chapter Moves <span className="text-[#D4AF37]">NC</span>
            </p>
            <p className="text-[#94A3B8] text-sm mt-1">
              Real Estate Guidance for the Next Chapter of Life
            </p>
          </div>
          
          <div className="flex items-center gap-6">
            <a 
              href="#about" 
              onClick={(e) => scrollToSection(e, "#about")}
              className="footer-link text-sm"
            >
              About
            </a>
            <a 
              href="#process" 
              onClick={(e) => scrollToSection(e, "#process")}
              className="footer-link text-sm"
            >
              Our Process
            </a>
            <a 
              href="#contact" 
              onClick={(e) => scrollToSection(e, "#contact")}
              className="footer-link text-sm"
            >
              Contact
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/10 mt-8 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#94A3B8] text-sm">
              © {currentYear} Next Chapter Moves NC. All rights reserved. | Knightdale, North Carolina
            </p>
            <div className="flex items-center gap-4">
              <Link to="/privacy" className="text-[#94A3B8] text-sm hover:text-[#D4AF37] transition-colors">
                Privacy Policy
              </Link>
              <span className="text-[#94A3B8]">|</span>
              <Link to="/terms" className="text-[#94A3B8] text-sm hover:text-[#D4AF37] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
